import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../Common/ChartsDynamicColor";

const Chart2 = ({ dataColors }) => {
  const apexsalesAnalyticsChartColors = getChartColorsArray(dataColors);
  const series = [50,35,30,24]
  const options = {
    labels: ["Draft", "Completed", "Accepted","Approved"],
    colors: apexsalesAnalyticsChartColors,
    legend: { show: false },
    dataLabels:{
      enabled:true,
      formatter: function(value, { seriesIndex, dataPointIndex, w }) { 
        return w.globals.series[seriesIndex]
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels:{
            show:false,
            colors:"#000"
          },
          size: "70%",
        },
      },
    },
    tooltip:{
      enabled:true,
      y: {
        show: true,
        formatter: (value)=>{
           return `${value}`
        },
      }
    },
    annotations: {
      position: 'center',
      yaxis: [
        {
          y: 0,
          y2: 1,
          label: {
            text: 'Total Transactions',
            style: {
              fontSize: '20px',
              color: '#333',
              background: 'transparent'
            }
          }
        }
      ]
    }
  };

  return (
    <React.Fragment>
      <Col xl="6">
        <Card >
          <CardBody>
            <h4 className="card-title mb-4">Deals Analytics</h4>

            <div style={{ position: 'relative' }}>
          <div id="donut-chart">
            <ReactApexChart
              options={options}
              series={series}
              type="donut"
              height={265}
              className="apex-charts"
            />
          </div>
          <div style={{ position: 'absolute', top: '45%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
            <span style={{ fontSize: '20px' }}>1342</span>
          </div>
          <div style={{ position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
          <span style={{ fontSize: '14px' }}>Transactions</span>
          </div>

        </div>
           <div className="text-center text-muted h-50" >
              <Row>
                <Col xs="3">
                  <div className="mt-5">
                    <p className="mb-2 text-truncate" title="Agrochemicals">
                      <i className="mdi mdi-circle text-primary me-1" /> Draft

                    </p>
                    {/* <h5>₹ 50.0L</h5> */}
                  </div>
                  {/* <p></p> */}
                </Col>
                <Col xs="3">
                  <div className="mt-5">
                    <p className="mb-2 text-truncate" title="Organic Farming">
                      <i className="mdi mdi-circle text-success me-1" /> Completed
                    </p>
                    {/* <h5>₹ 35.12L</h5> */}
                  </div>
                </Col>
                <Col xs="3">
                  <div className="mt-5">
                    <p className="mb-2 text-truncate" title="Tissue Calture G9 Plants">
                      <i className="mdi mdi-circle text-danger me-1" /> Accepted
                    </p>
                    {/* <h5>₹ 30.85L</h5> */}
                  </div>
                </Col>
                <Col xs="3">
                  <div className="mt-5">
                    <p className="mb-2 text-truncate" title="Seeds">
                      <i className="mdi mdi-circle text-info me-1" /> Approved
                    </p>
                    {/* <h5>₹ 24.36L</h5> */}
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Chart2;
